rimg.shopify.init('[data-rimg="lazy"]', { round: 1 });

const sections = new ShopifySectionsManager();

sections.register('age-gate', section => new AgeGate.PageAgeGate(section));

const ageGatePage = document.getElementById('age-gate-page');

if (ageGatePage) {
  new AgeGate.SiteAgeGate(ageGatePage);
}

// Document ready
$(() => {

  window.utils.enableDisclosure();
  const oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function () {
    const that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener('load', () => {
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  // Support for background images with new Lazysizes library
  document.addEventListener('lazyloaded', e => {
    let bg = e.target.getAttribute('data-bg');
    const mobileBg = e.target.getAttribute('data-mobile-bg');
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  window.imageFunctions.flickityIosFix();

  window.objectFitImages();
  window.header.init();
  window.meganavManager.injectAll();
  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.searchAutocomplete.init();
  }
  window.utils.initializeSectionWrapper();
  window.slideshow.init();
  window.testimonials.init();
  window.video.init();
  window.gallery.init();
  window.videoFeature.setupVideoPlayer();
  window.featuredPromotions.init();
  window.featuredCollection.init();
  window.logoList.init();
  window.collectionSidebarFilter.init();
  window.cart.init();
  window.map.init();
  window.shoppableImage.init();
  window.productPage.init();
  window.productPage.runOptionSelector();
  window.productPage.initializeQuantityBox();
  window.recentlyViewed.init();
  window.sidebarAccordions.init();

  if (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) {
    window.currencyConverter.init();
  }

  // Challenge page scroll

  // Return the pathname of the current URL
  const { pathname } = location;

  // If the pathname starts with '/challenge', animate scroll
  if (pathname.startsWith('/challenge')) {
    $('html, body').animate({
      scrollTop: 0,
    }, 'slow');
  }

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener('resize', () => {
    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        // Reset timeout
        resizeTimeout = null;
        // Grab screen width after screen is resized
        const currentScreenWidth = $(window).width();
        // Run our resize functions
        if (window.PXUTheme.media_queries.medium.matches && currentScreenWidth !== beforeResizeWidth) {
          window.cart.init();
          if (!window.is_touch_device()) {
            window.header.unload();
            window.header.init();
          }
        }

        window.logoList.init();

        // swap lazysizes background mobile images when browser is resized
        const lazysizesBackgroundImages = document.querySelectorAll('[data-bg]');
        lazysizesBackgroundImages.forEach(image => {
          let bg = image.getAttribute('data-bg');
          const mobileBg = image.getAttribute('data-mobile-bg');

          if (bg) {
            if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
              bg = mobileBg;
            }

            image.style.backgroundImage = `url(${bg})`;
          }
        });
      }, 66);
    }
  }, false);

  // Lightbox default options
  // https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === 'image') {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content.find('.fancybox-image-wrap').append(`<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`);
    }
  };

  // backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  // Find youtube and vimeo iframes
  const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    const ratio = width / height;

    // Determine ratio to be used
    if (Math.abs(ratio - 1 / 1) === 0) {
      return '1:1';
    }
    return (Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9)) ? '4:3' : '16:9';
  }

  $videoIframes.each((_index, iframe) => {
    // Update selector
    const $iframe = $(iframe);

    // Grab src
    const source = $iframe.attr('src');

    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
      $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
    }
  });

  // Initiate lazyframe
  window.lazyframe('.lazyframe');

  // Wrap shopify policy in grid layout classes
  $('.shopify-policy__container').wrap('<section class="section shopify-policy-template"><div class="container content"></div>');

  // Add classes to determine column size
  $('.shopify-policy__container').addClass('five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole');

  // Add featured divider beneath page title
  $('.shopify-policy__title').append('<div class="feature-divider"></div>');

  // Search input hiding
  // get current input
  const currentValue = $(".search__form input[name='q']").val();
  // return amount without *
  if ($(".search__form input[name='q']").length > 0) {
    $(".search__form input[name='q']").val(currentValue.replace('*', ''));
  }

  // Collection sorting

  const sortByEl = document.querySelector('[data-sort-by]');

  if (sortByEl) {
    sortByEl.addEventListener('change', e => {
      const { target } = e;
      const sortValue = target.value;
      if (target) {
        // Set the query string and redirect
        const queryString = new URLSearchParams(document.location.search);
        queryString.set('sort_by', sortValue);
        window.location.search = queryString;
      }
    });
  }

  $('body')
    .on('change', '#tag_filter', () => {
      $('[data-option-filter] input').prop('checked', false);
      window.quickFilter.init();
    });

  $('body')
    .on('change', '#blog_filter', function () {
      const url = $(this).val();
      window.location = url;
    });

  $('input, select, textarea').on('focus blur', event => {
    $('meta[name=viewport]').attr('content', `width=device-width,initial-scale=1,maximum-scale=${event.type === 'blur' ? 10 : 1}`);
  });

  // Collection sidebar filter
  // Check the checkbox values
  $('body').on('change', '[data-option-filter] input', () => {
    window.quickFilter.init();
    $('html, body').animate({
      scrollTop: ($('.content').offset().top),
    }, 500);
  });

  $('body').on('click', '[data-reset-filters]', () => {
    window.collectionSidebarFilter.clearAllFilters();
  });

  $('body').on('click', '[data-clear-filter]', e => {
    const $this = $(e.currentTarget);
    const selectedOption = $this.parents('.filter-active-tag');
    window.collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });

  $('body').on('change', '.currencies', () => {
    $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });

  $('body').on('change', '.js-quick-shop select', () => {
    const currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && window.globalQuickShopProduct) {
      window.quickShop.updateVariant(currentVariant);
    }
  });

  if (window.PXUTheme.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }

  let touchStartPos = 0;

  // Detecting swipe vs tap
  $(document).bind('touchstart', () => {
    touchStartPos = $(window).scrollTop();
  }).bind('touchend', e => {
    const distance = touchStartPos - $(window).scrollTop();
    if (distance > 20 || distance < -20) {
      e.preventDefault;
    }
  });

  $('body').on('click', '.sidebar .parent-link--false', function (e) {
    e.preventDefault();
    const $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });

  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }

  if (window.location.pathname.indexOf('/comments') !== -1) {
    $('html,body').animate({ scrollTop: $('#new-comment').offset().top - 140 }, 'slow');
  }

  $('body').on('mouseenter', '.icon-search', () => {
    $('.search-terms').focus();
  });

  $('body').on('click', '.icon-search', () => {
    $('input.search-terms').focus();
  });

  $('body').on('click', '.search-submit', e => {
    const $this = $(e.currentTarget);
    $this.parent().submit();
  });

  if (window.PXUTheme.media_queries.large.matches) {
    $('.animate_right').waypoint(function () {
      $(this.element).addClass('animated fadeInRight');
    }, { offset: '70%' });
    $('.animate_left').waypoint(function () {
      $(this.element).addClass('animated fadeInLeft');
    }, { offset: '70%' });
    $('.animate_up').waypoint(function () {
      $(this.element).addClass('animated fadeInUp');
    }, { offset: '70%' });
    $('.animate_down').waypoint(function () {
      $(this.element).addClass('animated fadeInDown');
    }, { offset: '70%' });
  }

  // backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: window.usePageDots,
    imagesLoaded: true,
    arrowShape: window.arrowSize,
    lazyLoad: 2,
  });

  window.utils.createAccordion('.footer_menu', 'h6', 'ul');
  window.utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  window.utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');
  // window.utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span');
  // window.utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

  window.utils.mobileParentActiveAccordion('.multistore-dropdown', '.multistore-dropdown li.sublink > a.parent-link--true span');
  window.utils.mobileAccordion('.multistore-dropdown', '.multistore-dropdown li.sublink > a.parent-link--false', '.multistore-dropdown li.sublink ul');

  window.utils.initializeTabs();
  window.accordion.init();


  
  //HERE

  const closeMobileMenuButton = document.querySelector('#mobile_menu .close-mobile-menu');
  const mobileMenuDetails = document.querySelector('div[data-mobile-menu-icon]');

  var parentLinks = document.querySelectorAll('.parent-link--true.first-level');
  var secondLevels = document.querySelectorAll(".second-level");
  var prevLinkSecondLevel = document.querySelectorAll(".second-level .prev-link");
  var sublinkA = document.querySelectorAll('.second-level .mobile-mega-menu_block.sublink .parent-link--true');

  closeMobileMenuButton.addEventListener('click', function () {
    mobileMenuDetails.click();

    document.querySelector('#mobile_menu .search__form').reset();
    document.querySelector('#mobile_menu .search__results-wrapper').style.display = 'none';
    
    if (secondLevels) {
      secondLevels.forEach(function (secondLevel) {
        secondLevel.classList.remove("is-visible");
      });
    }
    
    sublinkA.forEach((link, index) => {
      var thirdLevelCloseMenu = link.closest('.sublink').querySelector('.third-level');
      
      thirdLevelCloseMenu.classList.remove("is-visible");
    });
  });

  // Add a click event listener to each parent link
  parentLinks.forEach((parentLink, index) => {
    parentLink.addEventListener('click', function(event) {
      event.preventDefault();
      var secondLevel = secondLevels[index];

      // Toggle the display and right properties of the corresponding second-level element
      if (secondLevel.style.display === 'block') {
        secondLevel.classList.remove("is-visible");
      } else {
        secondLevel.style.right = '0';
        secondLevel.style.opacity = '1';
        secondLevel.classList.add("is-visible");
      }
    });
  });

  // Add a click event listener to each .prev-link within second-level elements
  prevLinkSecondLevel.forEach((prevLink, index) => {
    prevLink.addEventListener('click', function(event) {
      event.preventDefault();
      var secondLevel = prevLink.closest(".second-level");

      // Set .second-level's right and display properties

      
      secondLevel.style.right = '-100%';
      secondLevel.style.opacity = '0';
      
      function removeClass() {
        secondLevel.classList.remove("is-visible");
      }
  
      setTimeout(removeClass, 850);
    });
  });

  // Add a click event listener to each .sublink a element
  sublinkA.forEach((link, index) => {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      var thirdLevelOpen = link.closest('.sublink').querySelector('.third-level');

      // Set .third-level's right and display properties
      thirdLevelOpen.style.right = '0';
      thirdLevelOpen.style.opacity = '1';
      thirdLevelOpen.classList.add("is-visible");
    });
  });

  // Get all elements with class 'prev-link-third' inside .third-level
  var prevLinkThird = document.querySelectorAll('.third-level .prev-link-third');
  
  // Add click event listener to each .prev-link-third element
  prevLinkThird.forEach(function(prevLink) {
      prevLink.addEventListener('click', function(event) {
          event.preventDefault();
  
          // Find the parent element .third-level
          var thirdLevel = prevLink.closest('.third-level');
  
          // Remove 'is-visible' class from .third-level with a delay

          
          thirdLevel.style.right = '-100%';
          thirdLevel.style.opacity = '0';
        
         
      
          function removeClass() {
            thirdLevel.classList.remove("is-visible");
          }
      
          setTimeout(removeClass, 850);
      });
  });




  

  $('body').on('click', '.menu-toggle', function () {
    const $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
  });

  if (window.PXUTheme.theme_settings.collection_swatches) {
    if (window.PXUTheme.media_queries.large.matches) {
      $('body').on('mouseenter', '.collection_swatches', function () {
        $('.swatch span', $(this)).each(function () {
          if ($(this).data('image').indexOf('no-image') === -1) {
            $('<img/>')[0].src = $(this).data('image');
          }
        });
      });
      $('body').on('mouseenter', '.swatch span', function () {
        if ($(this).data('image').indexOf('no-image') === -1) {
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('src', $(this).data('image'));
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('srcset', $(this).data('image'));
        }
      });
    }
  }

  // Terms of service settings for minicart
  if (window.PXUTheme.theme_settings.display_tos_checkbox) {
    $('body').on('click touchstart', '.cart_content .tos_label', function () {
      $(this).prev('input').prop('checked', true);
    });
  }

  if (window.PXUTheme.theme_settings.display_tos_checkbox && window.PXUTheme.theme_settings.go_to_checkout) {
    // Terms of service on mini-cart && cart page
    $('body').on('click', '.tos_warning [data-cart-checkout-button]', function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        // Check if we are on the cart page or mini cart
        if (window.PXUTheme.theme_settings.go_to_checkout || $('body').hasClass('cart')) {
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = window.PXUTheme.routes.cart_url;
        }
      } else {
        const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning }</p>`;
        if ($('p.warning').length === 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else if (!window.PXUTheme.theme_settings.go_to_checkout) {
    $('body').on('click', '.cart_content [data-minicart-checkout-button]', e => {
      // Redirect to cart page
      e.preventDefault();
      document.location.href = window.PXUTheme.routes.cart_url;
    });
  }

  if (window.PXUTheme.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($('[data-is-required]').length) {
    const $checkboxGroup = $('.custom-contact__checkbox');
    $checkboxGroup.prop('required', true);

    $checkboxGroup.on('change', () => {
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(':checked')) {
        $checkboxGroup.prop('required', false);
      }
    });
  }

  $('.maps').click(() => {
    $('.maps iframe').css('pointer-events', 'auto');
  });

  // Load more / infinite load

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more') {
    window.enableLoadMoreProducts();
  }

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more_button') {
    window.enableLoadMoreButton('.product-list');
  }

  if (window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll') {
    window.enableInfiniteScroll('.product-list');
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  function ajaxSubmitCart(cart) {
    const $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      },
    });
  }

  function updateCartItemQuantity(cartItem) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        quantity: cartItem.quantity,
        line: cartItem.lineID,
      },
      success(data) {
        const cartItemsArray = data.items;
        const lineIDIndex = cartItem.lineID - 1;
        const totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
        const $quantityInputs = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
        let initialQuantityTotal = 0;
        let apiQuantityTotal = 0;
        const apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

        // Check if item has a "Buy X get Y" deal
        if ($quantityInputs.length > 1) {
          // Multiple inputs

          // Get all the quantities of same variants in the cart (including BOGO) in HTML
          $.each($quantityInputs, (_i, input) => {
            initialQuantityTotal += parseInt($(input).val());
          });

          // Get quantities from cart object returned from API
          cartItemsArray.forEach(item => {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          });
        } else {
          // Single input
          initialQuantityTotal = parseInt($quantityInputs.val());
          apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
        }

        // Checks to see if there is enough inventory to update to an increased amount
        if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
          if (apiQuantityTotal === 1) {
            itemsLeftText = window.PXUTheme.translation.one_item_left;
          } else {
            itemsLeftText = window.PXUTheme.translation.items_left_text;
          }

          $('.warning--quantity').remove();

          // Check if Buy one get one product
          if (totalCartItems < cartItemsArray.length) {
            if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
              // Refreshes cart if inventory is available
              cartItem.parentCartForm.submit();
            } else {
              refreshCart(data);
            }
          } else {
            const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).parent().after(warning);
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(apiLineItemQuantity);
          }
        } else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
          // Refreshes cart if inventory is available
          cartItem.parentCartForm.submit();
        } else {
          refreshCart(data);
        }
      },
    });
  }

  function refreshCartID() {
    const cartItem = document.querySelectorAll('.cart__item');

    for (let i = 0; i < cartItem.length; i++) {
      const lineIndex = i + 1;
      const dataLineId = cartItem[i].querySelectorAll('[data-line-id]');

      for (let c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }

  function refreshCart(cart) {
    $('.cart_count').empty();
    const $cartBtn = $('.cart_count');
    const value = $cartBtn.text() || '0';
    let cartItemsHTML = '';
    let cartDiscountsHTML = '';
    let cartActionHTML = '';
    let cartSavingsHTML = '';
    const $cartForm = $('[data-cart-form]');
    let productHasSale = false;
    let productCompareAtPrice = 0;
    let productFinalPrice = 0;

    $cartForm.data('total-discount', cart.total_discount);

    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

    if (cart.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cartForm.addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cartForm.removeClass('hidden');

      let totalSaving = 0; // adding counter variables for total cart savings
      let saving = 0;

      $.each(cart.items, (index, item) => {
        const itemDiscounts = item.discounts;
        let discountMessage = '';

        for (let i = 0; i < itemDiscounts.length; i++) {
          const { title } = itemDiscounts[i];
          discountMessage = `<p class="notification-discount meta">${title}</p>`;
        }
        const lineID = index + 1;

        cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}">`
          + `<a href="${item.url}">`;
        if (item.image) {
          cartItemsHTML += `${'<div class="cart_image">'
              + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />`
            + '</div></a>';
        }

        cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.title}</a>`;

        if (item.selling_plan_allocation) {
          cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
        }

        if (item.properties) {
          $.each(item.properties, (title, value) => {
            if (value && !title.startsWith('_')) { // Check if title doesn't start with "_"
              cartItemsHTML += `<div class="line-item">${title}: ${value}</div>`;
            }
          });
        }

        cartItemsHTML += '</div><div class="mini-cart__item-price">';

        $.ajax({
          dataType: 'json',
          async: false,
          cache: false,
          url: `/products/${item.handle}.js`,
          success(data) {
            let productData = data;
            // If item has more than one variant, need to make sure we are pulling data from the correct variant
            if (productData.variants) {
              const itemVariants = productData.variants;
              if (itemVariants.length > 1) {
                for (let v = 0; v < itemVariants.length; v++) {
                  if (itemVariants[v].id === item.id) {
                    productData = itemVariants[v];
                  }
                }
              }
            }

            // If compare at price exists then item is on sale
            if (productData.compare_at_price && productData.compare_at_price > productData.price) {
              productHasSale = true;
              productCompareAtPrice = productData.compare_at_price;
              productFinalPrice = productData.price;
            } else {
              // Check required for non-sale items
              productHasSale = false;
            }
          },
        });

        if (productHasSale === true) {
          // puts the slash through the old item price
          const itemPrice = `${window.Shopify.formatMoney(productFinalPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format'))}</span>`;
          cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;

          // Total savings
          saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
          totalSaving = saving + totalSaving;
        } else if (item.price > item.final_price) {
          // puts the slash through the old item price
          const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span>`;
          cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
        } else {
          const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format'));
          if (item.price > 0) {
            cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
          } else {
            cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`;
          }
        }

        cartItemsHTML += '</div>';

        // Unit price

        if (item.unit_price_measurement && item.price > 0) {
          let unitPriceMeasurementReferenceValue = '';

          if (item.unit_price_measurement.reference_value !== 1) {
            unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
          }

          cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
        }

        if (item.price > item.final_price) {
          cartItemsHTML += discountMessage;
        }

        cartItemsHTML += '<div class="product-quantity-box">';
        cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
        cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
        cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
        cartItemsHTML += '</div></div></div>';
        cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`;
      });

      const cartDiscounts = cart.cart_level_discount_applications;

      for (let i = 0; i < cartDiscounts.length; i++) {
        const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
        const { title } = cartDiscounts[i];

        cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
        cartDiscountsHTML += '<span class="cart_discounts--price">';
        cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
      }

      cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`;
      totalSaving += cart.total_discount;
      if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
        cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>`
            + `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
      } else {
        cartSavingsHTML = '';
      }
    }

    $('.js-cart_items').html(cartItemsHTML);
    $('.js-cart_discounts').html(cartDiscountsHTML);
    $('.js-cart_subtotal').html(cartActionHTML);
    $('.js-cart_savings').html(cartSavingsHTML);

    // Converting the currencies
    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }
  }

  // BEGIN: Upsell on cart popup
  $(document).on('click', '.upsell-add-button', function (e) {
    e.preventDefault();
    
    const $button = $(this);
    const variantId = $button.data('productid');
    const quantity = 1;
    
    $button.attr('disabled', 'disabled').addClass('disabled');
    
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        items: [{
          id: variantId,
          quantity: quantity
        }]
      },
      success() {
        $button.text('Added');
        
        setTimeout(() => {
          const buttonText = $button.hasClass('add-to-cart') ? 'Add to Bag' : 'Add';
          $button.removeAttr('disabled').removeClass('disabled').text(buttonText);
        }, 1000);
        
        $.ajax({
          url: '/cart.js',
          dataType: 'json',
          cache: false,
  
          success(cart) {
            refreshCart(cart);
            $('.cart-container').addClass('active_link');
            
            if (window.matchMedia('(max-width: 798px)').matches) {
              const header = document.getElementById('header');
              if (header && !header.classList.contains('mobile_nav-fixed--true')) {
                window.scroll({ top: 0, left: 0, behavior: 'smooth' });
              }
            }
          },
          error() {
            console.error('Error fetching cart data');
          }
        });
      },
      error(XMLHttpRequest) {
        let response = eval(`(${XMLHttpRequest.responseText})`);
        response = response.description;
        
        const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
        $button.after(warning);
        
        $button.removeAttr('disabled').removeClass('disabled').text('Add');
        
        setTimeout(() => {
          $('.warning').remove();
        }, 3000);
      }
    });
  });
  // END: Upsell on cart popup
  
  $('body').on('change', '[data-cart-quantity-input]', function () {
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: $(this).val(),
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]'),
    };
    // Disable button after click to prevent multiple clicks
    $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
    updateCartItemQuantity(cartItem);
  });

  $('body').on('click', '[data-remove-item]', function (e) {
    e.preventDefault();
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: 0,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]'),
    };
    cartItem.$element.addClass('animated fadeOutLeft');

    updateCartItemQuantity(cartItem);

    if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
      cartItem.$element.find('input').val('0');
      cartItem.parentCartForm.submit();
    }

    if (cartItem.parentCartForm.data('cart-form') === 'mini-cart') {
      cartItem.$element.find('input').val('0');
    }
  });

  if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      const $addToCartBtn = $addToCartForm.find('.add_to_cart');

      // Refresh page on quick shop add to cart if on cart page
      if ($('body').hasClass('cart')) {
        $addToCartForm.submit();
      }

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success() {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(() => {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCart(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.PXUTheme.media_queries.medium.matches) {
                  const $cartContainer = $(this).parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }

                  // Scroll to the top of the page unless the header is fixed
                  const header = document.getElementById('header');
                  if (header.classList.contains('mobile_nav-fixed--false')) {
                    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                  }
                }
              }, 500);
            },
          });
        },
        error(XMLHttpRequest) {
          let response = eval(`(${XMLHttpRequest.responseText})`);
          response = response.description;
          $('.warning').remove();

          const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        },
      });

      return false;
    });
  }

  window.productPage.productSwatches();
});


function refreshCartCollection(cart) {
  $('.cart_count').empty();
  const $cartBtn = $('.cart_count');
  const value = $cartBtn.text() || '0';
  var cartItemsHTML = '';
  var cartDiscountsHTML = '';
  var cartActionHTML = '';
  var cartSavingsHTML = '';
  const $cartForm = $('[data-cart-form]');
  var productHasSale = false;
  var productCompareAtPrice = 0;
  var productFinalPrice = 0;

  $cartForm.data('total-discount', cart.total_discount);

  $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

  if (cart.item_count === 0) {
    $('.js-empty-cart__message').removeClass('hidden');
    $cartForm.addClass('hidden');
  } else {
    $('.js-empty-cart__message').addClass('hidden');
    $cartForm.removeClass('hidden');

    var totalSaving = 0; // adding counter variables for total cart savings
    var saving = 0;

    $.each(cart.items, (index, item) => {
      const itemDiscounts = item.discounts;
      var discountMessage = '';

      for (var i = 0; i < itemDiscounts.length; i++) {
        const { title } = itemDiscounts[i];
        discountMessage = `<p class="notification-discount meta">${title}</p>`;
      }
      const lineID = index + 1;

      cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}">`
        + `<a href="${item.url}">`;
      if (item.image) {
        cartItemsHTML += `${'<div class="cart_image">'
            + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />`
          + '</div></a>';
      }

      cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.title}</a>`;

      if (item.selling_plan_allocation) {
        cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
      }

      if (item.properties) {
        $.each(item.properties, (title, value) => {
          if (value && !title.startsWith('_')) { // Check if title doesn't start with "_"
            cartItemsHTML += `<div class="line-item">${title}: ${value}</div>`;
          }
        });
      }

      cartItemsHTML += '</div><div class="mini-cart__item-price">';

      $.ajax({
        dataType: 'json',
        async: false,
        cache: false,
        url: `/products/${item.handle}.js`,
        success(data) {
          var productData = data;
          // If item has more than one variant, need to make sure we are pulling data from the correct variant
          if (productData.variants) {
            const itemVariants = productData.variants;
            if (itemVariants.length > 1) {
              for (var v = 0; v < itemVariants.length; v++) {
                if (itemVariants[v].id === item.id) {
                  productData = itemVariants[v];
                }
              }
            }
          }

          // If compare at price exists then item is on sale
          if (productData.compare_at_price && productData.compare_at_price > productData.price) {
            productHasSale = true;
            productCompareAtPrice = productData.compare_at_price;
            productFinalPrice = productData.price;
          } else {
            // Check required for non-sale items
            productHasSale = false;
          }
        },
      });

      if (productHasSale === true) {
        // puts the slash through the old item price
        const itemPrice = `${window.Shopify.formatMoney(productFinalPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format'))}</span>`;
        cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;

        // Total savings
        saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
        totalSaving = saving + totalSaving;
      } else if (item.price > item.final_price) {
        // puts the slash through the old item price
        const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span>`;
        cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
      } else {
        const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format'));
        if (item.price > 0) {
          cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
        } else {
          cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`;
        }
      }

      cartItemsHTML += '</div>';

      // Unit price

      if (item.unit_price_measurement && item.price > 0) {
        let unitPriceMeasurementReferenceValue = '';

        if (item.unit_price_measurement.reference_value !== 1) {
          unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
        }

        cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
      }

      if (item.price > item.final_price) {
        cartItemsHTML += discountMessage;
      }

      cartItemsHTML += '<div class="product-quantity-box">';
      cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
      cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
      cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
      cartItemsHTML += '</div></div></div>';
      cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`;
    });

    const cartDiscounts = cart.cart_level_discount_applications;

    for (let i = 0; i < cartDiscounts.length; i++) {
      const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
      const { title } = cartDiscounts[i];

      cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
      cartDiscountsHTML += '<span class="cart_discounts--price">';
      cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
    }

    cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`;
    totalSaving += cart.total_discount;
    if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
      cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>`
          + `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
    } else {
      cartSavingsHTML = '';
    }
  }

  $('.js-cart_items').html(cartItemsHTML);
  $('.js-cart_discounts').html(cartDiscountsHTML);
  $('.js-cart_subtotal').html(cartActionHTML);
  $('.js-cart_savings').html(cartSavingsHTML);

  // Converting the currencies
  if (window.PXUTheme.currency.show_multiple_currencies) {
    window.currencyConverter.convertCurrencies();
  }
}


// PRODUCT CARD ATC

function refreshCartCollection(cart) {
  $('.cart_count').empty();
  const $cartBtn = $('.cart_count');
  const value = $cartBtn.text() || '0';
  var cartItemsHTML = '';
  var cartDiscountsHTML = '';
  var cartActionHTML = '';
  var cartSavingsHTML = '';
  const $cartForm = $('[data-cart-form]');
  var productHasSale = false;
  var productCompareAtPrice = 0;
  var productFinalPrice = 0;

  $cartForm.data('total-discount', cart.total_discount);

  $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

  if (cart.item_count === 0) {
    $('.js-empty-cart__message').removeClass('hidden');
    $cartForm.addClass('hidden');
  } else {
    $('.js-empty-cart__message').addClass('hidden');
    $cartForm.removeClass('hidden');

    var totalSaving = 0; // adding counter variables for total cart savings
    var saving = 0;

    $.each(cart.items, (index, item) => {
      const itemDiscounts = item.discounts;
      var discountMessage = '';

      for (var i = 0; i < itemDiscounts.length; i++) {
        const { title } = itemDiscounts[i];
        discountMessage = `<p class="notification-discount meta">${title}</p>`;
      }
      const lineID = index + 1;

      cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}">`
        + `<a href="${item.url}">`;
      if (item.image) {
        cartItemsHTML += `${'<div class="cart_image">'
            + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />`
          + '</div></a>';
      }

      cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.title}</a>`;

      if (item.selling_plan_allocation) {
        cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
      }

      if (item.properties) {
        $.each(item.properties, (title, value) => {
          if (value && !title.startsWith('_')) { // Check if title doesn't start with "_"
            cartItemsHTML += `<div class="line-item">${title}: ${value}</div>`;
          }
        });
      }

      cartItemsHTML += '</div><div class="mini-cart__item-price">';

      $.ajax({
        dataType: 'json',
        async: false,
        cache: false,
        url: `/products/${item.handle}.js`,
        success(data) {
          var productData = data;
          // If item has more than one variant, need to make sure we are pulling data from the correct variant
          if (productData.variants) {
            const itemVariants = productData.variants;
            if (itemVariants.length > 1) {
              for (var v = 0; v < itemVariants.length; v++) {
                if (itemVariants[v].id === item.id) {
                  productData = itemVariants[v];
                }
              }
            }
          }

          // If compare at price exists then item is on sale
          if (productData.compare_at_price && productData.compare_at_price > productData.price) {
            productHasSale = true;
            productCompareAtPrice = productData.compare_at_price;
            productFinalPrice = productData.price;
          } else {
            // Check required for non-sale items
            productHasSale = false;
          }
        },
      });

      if (productHasSale === true) {
        // puts the slash through the old item price
        const itemPrice = `${window.Shopify.formatMoney(productFinalPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format'))}</span>`;
        cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;

        // Total savings
        saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
        totalSaving = saving + totalSaving;
      } else if (item.price > item.final_price) {
        // puts the slash through the old item price
        const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span>`;
        cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
      } else {
        const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format'));
        if (item.price > 0) {
          cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
        } else {
          cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`;
        }
      }

      cartItemsHTML += '</div>';

      // Unit price

      if (item.unit_price_measurement && item.price > 0) {
        let unitPriceMeasurementReferenceValue = '';

        if (item.unit_price_measurement.reference_value !== 1) {
          unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
        }

        cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
      }

      if (item.price > item.final_price) {
        cartItemsHTML += discountMessage;
      }

      cartItemsHTML += '<div class="product-quantity-box">';
      cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
      cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
      cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
      cartItemsHTML += '</div></div></div>';
      cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`;
    });

    const cartDiscounts = cart.cart_level_discount_applications;

    for (let i = 0; i < cartDiscounts.length; i++) {
      const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
      const { title } = cartDiscounts[i];

      cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
      cartDiscountsHTML += '<span class="cart_discounts--price">';
      cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
    }

    cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`;
    totalSaving += cart.total_discount;
    if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
      cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>`
          + `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
    } else {
      cartSavingsHTML = '';
    }
  }

  $('.js-cart_items').html(cartItemsHTML);
  $('.js-cart_discounts').html(cartDiscountsHTML);
  $('.js-cart_subtotal').html(cartActionHTML);
  $('.js-cart_savings').html(cartSavingsHTML);

  // Converting the currencies
  if (window.PXUTheme.currency.show_multiple_currencies) {
    window.currencyConverter.convertCurrencies();
  }
}

function addProductCollection(varId) {

      $addToCartForm =  {
          'items': [{
            'id': varId,
            'quantity': 1
          }]
        };
  
      const $addToCartBtn = $('.current-atc');

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm,
        beforeSend() {
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success() {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(() => {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
            $addToCartBtn.removeClass('current-atc');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCartCollection(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.PXUTheme.media_queries.medium.matches) {
                  const $cartContainer = $(this).parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }

                  // Scroll to the top of the page unless the header is fixed
                  const header = document.getElementById('header');
                  if (header.classList.contains('mobile_nav-fixed--false')) {
                    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                  }
                }
              }, 500);
            },
          });
        },
        error(XMLHttpRequest) {
          let response = eval(`(${XMLHttpRequest.responseText})`);
          response = response.description;
          $('.warning').remove();

          const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
          
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        },
      });

      return false;
}  

const atcCollectionButtons = document.querySelectorAll('.atc-collection');

atcCollectionButtons.forEach(button => {
  button.addEventListener('click', () => {
    button.classList.add('current-atc');
    var varId = button.getAttribute('data-first-id');
    addProductCollection(varId);
  });
});

// MINIS PAGE

const minisPage = document.querySelector('.minis-page');

if (minisPage) {
function refreshCartMinis(cart) {
    $('.cart_count').empty();
    const $cartBtn = $('.cart_count');
    const value = $cartBtn.text() || '0';
    let cartItemsHTML = '';
    let cartDiscountsHTML = '';
    let cartActionHTML = '';
    let cartSavingsHTML = '';
    const $cartForm = $('[data-cart-form]');
    let productHasSale = false;
    let productCompareAtPrice = 0;
    let productFinalPrice = 0;

    $cartForm.data('total-discount', cart.total_discount);

    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

    if (cart.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cartForm.addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cartForm.removeClass('hidden');

      let totalSaving = 0; // adding counter variables for total cart savings
      let saving = 0;

      $.each(cart.items, (index, item) => {
        const itemDiscounts = item.discounts;
        let discountMessage = '';

        for (let i = 0; i < itemDiscounts.length; i++) {
          const { title } = itemDiscounts[i];
          discountMessage = `<p class="notification-discount meta">${title}</p>`;
        }
        const lineID = index + 1;

        cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}">`
          + `<a href="${item.url}">`;
        if (item.image) {
          cartItemsHTML += `${'<div class="cart_image">'
              + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />`
            + '</div></a>';
        }

        cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.title}</a>`;

        if (item.selling_plan_allocation) {
          cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
        }

        if (item.properties) {
          $.each(item.properties, (title, value) => {
            if (value && !title.startsWith('_')) { // Check if title doesn't start with "_"
              cartItemsHTML += `<div class="line-item">${title}: ${value}</div>`;
            }
          });
        }

        cartItemsHTML += '</div><div class="mini-cart__item-price">';

        $.ajax({
          dataType: 'json',
          async: false,
          cache: false,
          url: `/products/${item.handle}.js`,
          success(data) {
            let productData = data;
            // If item has more than one variant, need to make sure we are pulling data from the correct variant
            if (productData.variants) {
              const itemVariants = productData.variants;
              if (itemVariants.length > 1) {
                for (let v = 0; v < itemVariants.length; v++) {
                  if (itemVariants[v].id === item.id) {
                    productData = itemVariants[v];
                  }
                }
              }
            }

            // If compare at price exists then item is on sale
            if (productData.compare_at_price && productData.compare_at_price > productData.price) {
              productHasSale = true;
              productCompareAtPrice = productData.compare_at_price;
              productFinalPrice = productData.price;
            } else {
              // Check required for non-sale items
              productHasSale = false;
            }
          },
        });

        if (productHasSale === true) {
          // puts the slash through the old item price
          const itemPrice = `${window.Shopify.formatMoney(productFinalPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format'))}</span>`;
          cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;

          // Total savings
          saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
          totalSaving = saving + totalSaving;
        } else if (item.price > item.final_price) {
          // puts the slash through the old item price
          const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span>`;
          cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
        } else {
          const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format'));
          if (item.price > 0) {
            cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
          } else {
            cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`;
          }
        }

        cartItemsHTML += '</div>';

        // Unit price

        if (item.unit_price_measurement && item.price > 0) {
          let unitPriceMeasurementReferenceValue = '';

          if (item.unit_price_measurement.reference_value !== 1) {
            unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
          }

          cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
        }

        if (item.price > item.final_price) {
          cartItemsHTML += discountMessage;
        }

        cartItemsHTML += '<div class="product-quantity-box">';
        cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
        cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
        cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
        cartItemsHTML += '</div></div></div>';
        cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`;
      });

      const cartDiscounts = cart.cart_level_discount_applications;

      for (let i = 0; i < cartDiscounts.length; i++) {
        const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
        const { title } = cartDiscounts[i];

        cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
        cartDiscountsHTML += '<span class="cart_discounts--price">';
        cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
      }

      cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`;
      totalSaving += cart.total_discount;
      if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
        cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>`
            + `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
      } else {
        cartSavingsHTML = '';
      }
    }

    $('.js-cart_items').html(cartItemsHTML);
    $('.js-cart_discounts').html(cartDiscountsHTML);
    $('.js-cart_subtotal').html(cartActionHTML);
    $('.js-cart_savings').html(cartSavingsHTML);

    // Converting the currencies
    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }
  }


// Get all product-item elements
const productItems = document.querySelectorAll('.product-item');

// Get the add-to-cart, note, and selection-grid elements
const addToCart = document.querySelector('.add-to-cart');
const note = document.querySelector('.note');
const totalSelectionPrice = document.querySelector('.total-selection-price');
const totalComparedSelectionPrice = document.querySelector('.total-compared-selection-price');
const selectionGridItems = document.querySelectorAll('.selection-grid .selection-item');

var freeGift = theme.strings.minisFreeGift;
var freeGiftId = theme.strings.minisFreeGiftVariantId;

// Create an empty array to store selected variants and their prices
var selectedVariants = { items: [], totalPrice: 0, comparedPrice: 0 };

// Loop through each product-item element
productItems.forEach(productItem => {
  // Add a click event listener to each product-item element
  productItem.addEventListener('click', () => {

    // If the product-item is already selected, remove the selected class and remove its variant from the array
    if (productItem.classList.contains('selected')) {
      productItem.classList.remove('selected');
      const dataVariant = productItem.querySelector('[data-variant]').getAttribute('data-variant');
      const variantPrice = parseFloat(productItem.querySelector('[data-price]').getAttribute('data-price'));
      const variantComparedPrice = parseFloat(productItem.querySelector('[data-compared]').getAttribute('data-compared'));
      selectedVariants.items = selectedVariants.items.filter(variant => variant.id !== dataVariant);
      selectedVariants.totalPrice -= variantPrice;
      selectedVariants.comparedPrice -= variantComparedPrice;

      // Remove the corresponding selection item from the selection grid
      const selectionItem = document.querySelector(`.selection-item[data-variant="${dataVariant}"]`);
      if (selectionItem) {
        selectionItem.innerHTML = '';
        selectionItem.removeAttribute('data-variant');
      }
    } else {
      // If 5 variants have already been selected, find and show the note element in the clicked product-item
      if (selectedVariants.items.length === 5) {
        const noteElement = productItem.querySelector('.note');
        if (noteElement) {
          noteElement.style.display = 'block';
          setTimeout(() => {
            noteElement.style.display = 'none';
          }, 2000);
        }
      } else {
        // Add the "selected" class to the clicked product-item element
        productItem.classList.add('selected');

        // Get the data-variant and data-price attributes from the clicked product-item element
        const dataVariant = productItem.querySelector('[data-variant]').getAttribute('data-variant');
        const variantPrice = parseFloat(productItem.querySelector('[data-price]').getAttribute('data-price'));
        const variantComparedPrice = parseFloat(productItem.querySelector('[data-compared]').getAttribute('data-compared'));

        // Add the data-variant attribute value as a new object to the selectedVariants array with quantity 1
        selectedVariants.items.push({ id: dataVariant, quantity: 1 });
        selectedVariants.totalPrice += variantPrice;
        selectedVariants.comparedPrice += variantComparedPrice;

        if (selectedVariants.comparedPrice/100 > 0) {
          totalComparedSelectionPrice.style.display = 'block';
        }

        // Find an empty selection item in the selection grid and add the corresponding product-item
        for (var i = 0; i < selectionGridItems.length; i++) {
          const selectionItem = selectionGridItems[i];
          if (selectionItem.innerHTML === '') {
            selectionItem.appendChild(productItem.querySelector('.item').cloneNode(true));
            selectionItem.setAttribute('data-variant', dataVariant);
            break;
          }
        }
      }
    }

    // Check if 3 or more variants have been selected and show the add-to-cart element
    if (selectedVariants.items.length >= 3) {
      addToCart.classList.remove('disabled');
      addToCart.querySelector('.text').textContent = "ADD TO BAG";
    } else {
      // Hide the add-to-cart element
      addToCart.classList.add('disabled');
      addToCart.querySelector('.text').textContent = "A MINIMUM OF 3 MINIS NEED TO BE ADDED";
    }

    // Check if 5 variants have been selected and scroll the page to .step-2 smoothly
    if (selectedVariants.items.length === 5 && productItem.classList.contains('selected')) {
      const step2 = document.querySelector('.step-2');
      step2.scrollIntoView({ behavior: 'smooth' });
    }

    // Display the total selection price on the page
    totalSelectionPrice.innerHTML = window.Shopify.formatMoney(`${selectedVariants.totalPrice}`, $('body').data('money-format'));
    totalComparedSelectionPrice.innerHTML = window.Shopify.formatMoney(`${selectedVariants.comparedPrice}`, $('body').data('money-format'));

    if (selectedVariants.comparedPrice/100 <= 0) {
      totalComparedSelectionPrice.style.display = 'none';
    }

    // Log the selected variants to the console
    // console.log(selectedVariants);
  });
});

function addProducts(event) {
  event.preventDefault();

  // Add gift product to selectedVariants

      const $addToCartBtn = $('.minis-page .add_to_cart');

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: { items: selectedVariants.items.concat({ id: freeGiftId, quantity: 1 }) },
        beforeSend() {
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success() {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(() => {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCartMinis(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.PXUTheme.media_queries.medium.matches) {
                  const $cartContainer = $(this).parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }

                  // Scroll to the top of the page unless the header is fixed
                  const header = document.getElementById('header');
                  if (header.classList.contains('mobile_nav-fixed--false')) {
                    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                  }
                }
              }, 500);
            },
          });
        },
        error(XMLHttpRequest) {
          try {
            const response = JSON.parse(XMLHttpRequest.responseText);
            const errorMessage = response.description || 'An error occurred';
            $('.warning').remove();

            const warning = `<p class="warning animated bounceIn">${errorMessage.replace('All 1 ', 'All ')}</p>`;
            $addToCartBtn.after(warning);
          } catch (e) {
            console.error('Error parsing response:', e);
          }
          
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        },
      });

      return false;
}

addToCart.addEventListener('click', addProducts);
}

const routinePage = document.querySelector('.page-find-your-routine-page');

if (routinePage) {
  // Get references to the DOM elements
const step1 = document.getElementById('step1');
const step2 = document.getElementById('step2');
const step3 = document.getElementById('step3');
const stage1 = document.querySelector('.stage-1');
const stage2 = document.querySelector('.stage-2');
const stage3 = document.querySelector('.stage-3');
const progress = document.querySelector('.progress');
const recommendation = document.getElementById('recommendation');
var result = '';
var result1 = '';
var result2 = '';
var result3 = '';

  console.log(result);

// Attach click event listeners to the options in step 1
const step1Options = document.querySelectorAll('#step1 .questions-grid input[type="radio"]');
step1Options.forEach(option => {
  option.addEventListener('click', () => {
    
    result1 = option.dataset.result;
    console.log(result1);

    const resultProducts1 = document.querySelectorAll('#products1 .result-product[data-show-result]');

    resultProducts1.forEach(product => {
      if (product.getAttribute('data-show-result').split(',').includes(result1)) {
        product.style.display = "block"; // show the element
      } else {
        product.style.display = "none"; // hide the element
      }
    });
    
    // Hide step 1 and show step 2
    step1.style.display = 'none';
    step2.style.display = 'block';
    stage1.classList.remove('active');
    stage2.classList.add('active');
  });
});

// Attach click event listeners to the options in step 2
const step2Options = document.querySelectorAll('#step2 .questions-grid input[type="radio"]');
step2Options.forEach(option => {
  option.addEventListener('click', () => {

    result2 = option.dataset.result2;
    result3 = option.dataset.result;
    result5 = option.dataset.result3;
    console.log(result2);
    console.log(result3);

    const resultProducts2 = document.querySelectorAll('#products2 .result-product[data-show-result]');
    const resultProducts3 = document.querySelectorAll('#products3 .result-product[data-show-result]');
    const resultProducts5 = document.querySelectorAll('#products1-2 .result-product[data-show-result]');

    resultProducts2.forEach(product => {
      if (product.getAttribute('data-show-result').split(',').includes(result2)) {
        product.style.display = "block"; // show the element
      } else {
        product.style.display = "none"; // hide the element
      }
    });
    
    resultProducts3.forEach(product => {
      if (product.getAttribute('data-show-result').split(',').includes(result3)) {
        product.style.display = "block"; // show the element
      } else {
        product.style.display = "none"; // hide the element
      }
    });

    resultProducts5.forEach(product => {
      if (product.getAttribute('data-show-result').split(',').includes(result5)) {
        product.style.display = "block"; // show the element
      } else {
        product.style.display = "none"; // hide the element
      }
    });
    
    // Hide step 2 and show step 3
    step2.style.display = 'none';
    step3.style.display = 'block';
    stage2.classList.remove('active');
    stage3.classList.add('active')
  });
});

// Attach click event listeners to the options in step 3
const step3Options = document.querySelectorAll('#step3 .questions-grid input[type="radio"]');
step3Options.forEach(option => {
  option.addEventListener('click', () => {

    result4 = option.dataset.result;
    console.log(result4);

    const resultProducts4 = document.querySelectorAll('#products4 .result-product[data-show-result]');
    
    resultProducts4.forEach(product => {
      if (product.getAttribute('data-show-result').split(',').includes(result4)) {
        product.style.display = "block"; // show the element
      } else {
        product.style.display = "none"; // hide the element
      }
    });
    
    // Hide step 3 and show the recommendation
    step3.style.display = 'none';
    recommendation.style.display = 'block';
    progress.style.display = 'none';
  });
});

function refreshCartRoutine(cart) {
  $('.cart_count').empty();
  const $cartBtn = $('.cart_count');
  const value = $cartBtn.text() || '0';
  var cartItemsHTML = '';
  var cartDiscountsHTML = '';
  var cartActionHTML = '';
  var cartSavingsHTML = '';
  const $cartForm = $('[data-cart-form]');
  var productHasSale = false;
  var productCompareAtPrice = 0;
  var productFinalPrice = 0;

  $cartForm.data('total-discount', cart.total_discount);

  $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

  if (cart.item_count === 0) {
    $('.js-empty-cart__message').removeClass('hidden');
    $cartForm.addClass('hidden');
  } else {
    $('.js-empty-cart__message').addClass('hidden');
    $cartForm.removeClass('hidden');

    var totalSaving = 0; // adding counter variables for total cart savings
    var saving = 0;

    $.each(cart.items, (index, item) => {
      const itemDiscounts = item.discounts;
      var discountMessage = '';

      for (var i = 0; i < itemDiscounts.length; i++) {
        const { title } = itemDiscounts[i];
        discountMessage = `<p class="notification-discount meta">${title}</p>`;
      }
      const lineID = index + 1;

      cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}">`
        + `<a href="${item.url}">`;
      if (item.image) {
        cartItemsHTML += `${'<div class="cart_image">'
            + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />`
          + '</div></a>';
      }

      cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.title}</a>`;

      if (item.selling_plan_allocation) {
        cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
      }

      if (item.properties) {
        $.each(item.properties, (title, value) => {
          if (value && !title.startsWith('_')) { // Check if title doesn't start with "_"
            cartItemsHTML += `<div class="line-item">${title}: ${value}</div>`;
          }
        });
      }

      cartItemsHTML += '</div><div class="mini-cart__item-price">';

      $.ajax({
        dataType: 'json',
        async: false,
        cache: false,
        url: `/products/${item.handle}.js`,
        success(data) {
          var productData = data;
          // If item has more than one variant, need to make sure we are pulling data from the correct variant
          if (productData.variants) {
            const itemVariants = productData.variants;
            if (itemVariants.length > 1) {
              for (var v = 0; v < itemVariants.length; v++) {
                if (itemVariants[v].id === item.id) {
                  productData = itemVariants[v];
                }
              }
            }
          }

          // If compare at price exists then item is on sale
          if (productData.compare_at_price && productData.compare_at_price > productData.price) {
            productHasSale = true;
            productCompareAtPrice = productData.compare_at_price;
            productFinalPrice = productData.price;
          } else {
            // Check required for non-sale items
            productHasSale = false;
          }
        },
      });

      if (productHasSale === true) {
        // puts the slash through the old item price
        const itemPrice = `${window.Shopify.formatMoney(productFinalPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format'))}</span>`;
        cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;

        // Total savings
        saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
        totalSaving = saving + totalSaving;
      } else if (item.price > item.final_price) {
        // puts the slash through the old item price
        const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span>`;
        cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
      } else {
        const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format'));
        if (item.price > 0) {
          cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
        } else {
          cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`;
        }
      }

      cartItemsHTML += '</div>';

      // Unit price

      if (item.unit_price_measurement && item.price > 0) {
        let unitPriceMeasurementReferenceValue = '';

        if (item.unit_price_measurement.reference_value !== 1) {
          unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
        }

        cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
      }

      if (item.price > item.final_price) {
        cartItemsHTML += discountMessage;
      }

      cartItemsHTML += '<div class="product-quantity-box">';
      cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
      cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
      cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
      cartItemsHTML += '</div></div></div>';
      cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`;
    });

    const cartDiscounts = cart.cart_level_discount_applications;

    for (let i = 0; i < cartDiscounts.length; i++) {
      const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
      const { title } = cartDiscounts[i];

      cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
      cartDiscountsHTML += '<span class="cart_discounts--price">';
      cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
    }

    cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`;
    totalSaving += cart.total_discount;
    if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
      cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>`
          + `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
    } else {
      cartSavingsHTML = '';
    }
  }

  $('.js-cart_items').html(cartItemsHTML);
  $('.js-cart_discounts').html(cartDiscountsHTML);
  $('.js-cart_subtotal').html(cartActionHTML);
  $('.js-cart_savings').html(cartSavingsHTML);

  // Converting the currencies
  if (window.PXUTheme.currency.show_multiple_currencies) {
    window.currencyConverter.convertCurrencies();
  }
}

function addProductsRoutine(varId) {

  console.log(varId);

      $addToCartForm =  {
          'items': [{
            'id': varId,
            'quantity': 1
          }]
        };
  
      const $addToCartBtn = $('.current-atc');

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm,
        beforeSend() {
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success() {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(() => {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
            $addToCartBtn.removeClass('current-atc');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCartRoutine(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.PXUTheme.media_queries.medium.matches) {
                  const $cartContainer = $(this).parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }

                  // Scroll to the top of the page unless the header is fixed
                  const header = document.getElementById('header');
                  if (header.classList.contains('mobile_nav-fixed--false')) {
                    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                  }
                }
              }, 500);
            },
          });
        },
        error(XMLHttpRequest) {
          let response = eval(`(${XMLHttpRequest.responseText})`);
          response = response.description;
          $('.warning').remove();

          const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
          
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        },
      });

      return false;
}  

const atcButtons = document.querySelectorAll('.add-to-cart');

  atcButtons.forEach(button => {
    button.addEventListener('click', () => {
      button.classList.add('current-atc');
      var varId = button.getAttribute('data-variant');
      addProductsRoutine(varId);
    });
  });
  
}


/*= ===========================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
============================================================================== */
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
  }

  const availableOptions = Shopify.optionsMap[key];
  $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled')
        .removeAttr('checked');
    } else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked')
        .attr('disabled', 'disabled');
    }
  });
};

window.Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  window.Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(`${parent} .single-option-selector:eq(0)`).change(() => {
    window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  // When there is an update in the second dropdown.
  $(`${parent} .single-option-selector:eq(1)`).change(() => {
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  }
  return '';
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);

/* option_selection.js */
function floatToString(t, e) { const o = t.toFixed(e).toString(); return o.match(/^\.\d+/) ? `0${o}` : o; } if (typeof window.Shopify === 'undefined') window.Shopify = {}; window.Shopify.each = function (t, e) { for (let o = 0; o < t.length; o++)e(t[o], o); }, window.Shopify.map = function (t, e) { for (var o = [], i = 0; i < t.length; i++)o.push(e(t[i], i)); return o; }, window.Shopify.arrayIncludes = function (t, e) { for (let o = 0; o < t.length; o++) if (t[o] == e) return !0; return !1; }, window.Shopify.uniq = function (t) { for (var e = [], o = 0; o < t.length; o++)window.Shopify.arrayIncludes(e, t[o]) || e.push(t[o]); return e; }, window.Shopify.isDefined = function (t) { return typeof t === 'undefined' ? !1 : !0; }, window.Shopify.getClass = function (t) { return Object.prototype.toString.call(t).slice(8, -1); }, window.Shopify.extend = function (t, e) { function o() {}o.prototype = e.prototype, t.prototype = new o(), t.prototype.constructor = t, t.baseConstructor = e, t.superClass = e.prototype; }, window.Shopify.locationSearch = function () { return window.location.search; }, window.Shopify.locationHash = function () { return window.location.hash; }, window.Shopify.replaceState = function (t) { window.history.replaceState({}, document.title, t); }, window.Shopify.urlParam = function (t) { const e = RegExp(`[?&]${t}=([^&#]*)`).exec(window.Shopify.locationSearch()); return e && decodeURIComponent(e[1].replace(/\+/g, ' ')); }, window.Shopify.newState = function (t, e) { let o; return o = window.Shopify.urlParam(t) ? window.Shopify.locationSearch().replace(RegExp(`(${t}=)[^&#]+`), `$1${e}`) : window.Shopify.locationSearch() === '' ? `?${t}=${e}` : `${window.Shopify.locationSearch()}&${t}=${e}`, o + window.Shopify.locationHash(); }, window.Shopify.setParam = function (t, e) { window.Shopify.replaceState(window.Shopify.newState(t, e)); }, window.Shopify.Product = function (t) { window.Shopify.isDefined(t) && this.update(t); }, window.Shopify.Product.prototype.update = function (t) { for (property in t) this[property] = t[property]; }, window.Shopify.Product.prototype.optionNames = function () { return window.Shopify.getClass(this.options) == 'Array' ? this.options : []; }, window.Shopify.Product.prototype.optionValues = function (t) { if (!window.Shopify.isDefined(this.variants)) return null; const e = window.Shopify.map(this.variants, e => { const o = `option${t + 1}`; return void 0 == e[o] ? null : e[o]; }); return e[0] == null ? null : window.Shopify.uniq(e); }, window.Shopify.Product.prototype.getVariant = function (t) { let e = null; return t.length != this.options.length ? e : (window.Shopify.each(this.variants, o => { for (var i = !0, r = 0; r < t.length; r++) { const n = `option${r + 1}`; o[n] != t[r] && (i = !1); } return i == 1 ? void (e = o) : void 0; }), e); }, window.Shopify.Product.prototype.getVariantById = function (t) { for (let e = 0; e < this.variants.length; e++) { const o = this.variants[e]; if (t == o.id) return o; } return null; }, window.Shopify.money_format = '$', window.Shopify.formatMoney = function (t, e) { function o(t, e) { return typeof t === 'undefined' ? e : t; } function i(t, e, i, r) { if (e = o(e, 2), i = o(i, ','), r = o(r, '.'), isNaN(t) || t == null) return 0; t = (t / 100).toFixed(e); const n = t.split('.'); const a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`); const s = n[1] ? r + n[1] : ''; return a + s; } typeof t === 'string' && (t = t.replace('.', '')); let r = ''; const n = /\{\{\s*(\w+)\s*\}\}/; const a = e || this.money_format; switch (a.match(n)[1]) { case 'amount': r = i(t, 2); break; case 'amount_no_decimals': r = i(t, 0); break; case 'amount_with_comma_separator': r = i(t, 2, '.', ','); break; case 'amount_with_apostrophe_separator': r = i(t, 2, "'", '.'); break; case 'amount_no_decimals_with_comma_separator': r = i(t, 0, '.', ','); } return a.replace(n, r); }, window.Shopify.OptionSelectors = function (t, e) { return this.selectorDivClass = 'selector-wrapper', this.selectorClass = 'single-option-selector', this.variantIdFieldIdSuffix = '-variant-id', this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = t, this.product = new window.Shopify.Product(e.product), this.onVariantSelected = window.Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function () {}, this.replaceSelector(t), this.initDropdown(), e.enableHistoryState && (this.historyState = new window.Shopify.OptionSelectors.HistoryState(this)), !0; }, window.Shopify.OptionSelectors.prototype.initDropdown = function () { const t = { initialLoad: !0 }; const e = this.selectVariantFromDropdown(t); if (!e) { const o = this; setTimeout(() => { o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t); }); } }, window.Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (t) { this.selectors[0].element.onchange(t); }, window.Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (t) { const e = this.selectVariantFromParams(t); e || this.selectVariantFromDropdown(t); }, window.Shopify.OptionSelectors.prototype.replaceSelector = function (t) { const e = document.getElementById(t); const o = e.parentNode; window.Shopify.each(this.buildSelectors(), t => { o.insertBefore(t, e); }), e.style.display = 'none', this.variantIdField = e; }, window.Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (t) { let e = document.getElementById(this.domIdPrefix).querySelector('[selected]'); if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e) return !1; const o = e.value; return this.selectVariant(o, t); }, window.Shopify.OptionSelectors.prototype.selectVariantFromParams = function (t) { const e = window.Shopify.urlParam('variant'); return this.selectVariant(e, t); }, window.Shopify.OptionSelectors.prototype.selectVariant = function (t, e) { const o = this.product.getVariantById(t); if (o == null) return !1; for (let i = 0; i < this.selectors.length; i++) { const r = this.selectors[i].element; const n = r.getAttribute('data-option'); const a = o[n]; a != null && this.optionExistInSelect(r, a) && (r.value = a); } return typeof jQuery !== 'undefined' ? jQuery(this.selectors[0].element).trigger('change', e) : this.selectors[0].element.onchange(e), !0; }, window.Shopify.OptionSelectors.prototype.optionExistInSelect = function (t, e) { for (let o = 0; o < t.options.length; o++) if (t.options[o].value == e) return !0; }, window.Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) { window.Shopify.isDefined(e) && this.setMessageElement(e), this.domIdPrefix = `product-${this.product.id}-variant-selector`; const o = document.getElementById(t); window.Shopify.each(this.buildSelectors(), t => { o.appendChild(t); }); }, window.Shopify.OptionSelectors.prototype.buildSelectors = function () { for (let t = 0; t < this.product.optionNames().length; t++) { const e = new window.Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t)); e.element.disabled = !1, this.selectors.push(e); } const o = this.selectorDivClass; const i = this.product.optionNames(); const r = window.Shopify.map(this.selectors, t => { const e = document.createElement('div'); if (e.setAttribute('class', o), i.length > 1) { const r = document.createElement('label'); r.htmlFor = t.element.id, r.innerHTML = t.name, e.appendChild(r); } return e.appendChild(t.element), e; }); return r; }, window.Shopify.OptionSelectors.prototype.selectedValues = function () { for (var t = [], e = 0; e < this.selectors.length; e++) { const o = this.selectors[e].element.value; t.push(o); } return t; }, window.Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) { const o = this.selectedValues(); const i = this.product.getVariant(o); i ? (this.variantIdField.disabled = !1, this.variantIdField.value = i.id) : this.variantIdField.disabled = !0, this.onVariantSelected(i, this, e), this.historyState != null && this.historyState.onVariantChange(i, this, e); }, window.Shopify.OptionSelectorsFromDOM = function (t, e) { const o = e.optionNames || []; const i = e.priceFieldExists || !0; const r = e.delimiter || '/'; const n = this.createProductFromSelector(t, o, i, r); e.product = n, window.Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e); }, window.Shopify.extend(window.Shopify.OptionSelectorsFromDOM, window.Shopify.OptionSelectors), window.Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (t, e, o, i) {
  if (!window.Shopify.isDefined(o)) var o = !0; if (!window.Shopify.isDefined(i)) var i = '/'; const r = document.getElementById(t); const n = r.childNodes; let a = (r.parentNode, e.length); const s = []; window.Shopify.each(n, (t, r) => {
    if (t.nodeType == 1 && t.tagName.toLowerCase() == 'option') {
      const n = t.innerHTML.split(new RegExp(`\\s*\\${i}\\s*`)); e.length == 0 && (a = n.length - (o ? 1 : 0)); const p = n.slice(0, a); const l = o ? n[a] : ''; const c = (t.getAttribute('value'), {
        available: t.disabled ? !1 : !0, id: parseFloat(t.value), price: l, option1: p[0], option2: p[1], option3: p[2],
      }); s.push(c);
    }
  }); const p = { variants: s }; if (e.length == 0) { p.options = []; for (let l = 0; a > l; l++)p.options[l] = `option ${l + 1}`; } else p.options = e; return p;
}, window.Shopify.SingleOptionSelector = function (t, e, o, i) { this.multiSelector = t, this.values = i, this.index = e, this.name = o, this.element = document.createElement('select'); for (let r = 0; r < i.length; r++) { const n = document.createElement('option'); n.value = i[r], n.innerHTML = i[r], this.element.appendChild(n); } return this.element.setAttribute('class', this.multiSelector.selectorClass), this.element.setAttribute('data-option', `option${e + 1}`), this.element.id = `${t.domIdPrefix}-option-${e}`, this.element.onchange = function (o, i) { i = i || {}, t.updateSelectors(e, i); }, !0; }, window.Shopify.Image = {
  preload(t, e) { for (let o = 0; o < t.length; o++) { const i = t[o]; this.loadImage(this.getSizedImageUrl(i, e)); } }, loadImage(t) { (new Image()).src = t; }, switchImage(t, e, o) { if (t && e) { const i = this.imageSize(e.src); const r = this.getSizedImageUrl(t.src, i); o ? o(r, t, e) : e.src = r; } }, imageSize(t) { const e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./); return e != null ? e[1] : null; }, getSizedImageUrl(t, e) { if (e == null) return t; if (e == 'master') return this.removeProtocol(t); const o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i); if (o != null) { const i = t.split(o[0]); const r = o[0]; return this.removeProtocol(`${i[0]}_${e}${r}`); } return null; }, removeProtocol(t) { return t.replace(/http(s)?:/, ''); },
}, window.Shopify.OptionSelectors.HistoryState = function (t) { this.browserSupports() && this.register(t); }, window.Shopify.OptionSelectors.HistoryState.prototype.register = function (t) { window.addEventListener('popstate', e => { t.selectVariantFromParamsOrDropdown({ popStateCall: !0 }); }); }, window.Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (t, e, o) { this.browserSupports() && (!t || o.initialLoad || o.popStateCall || window.Shopify.setParam('variant', t.id)); }, window.Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () { return window.history && window.history.replaceState; };

$(document)
  .on('shopify:block:select', e => {
    const { blockId } = e.detail;
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials') || $parentSection.hasClass('shopify-section--shoppable-image--slider-enabled')) {
      sliderBlock.select(blockId, $parentSection);
    }
  });

$(document)
  .on('shopify:block:deselect', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials')) {
      window.sliderBlock.deselect($parentSection);
    }
  });

$(document)
  .on('shopify:section:reorder', e => {
    window.utils.initializeSectionWrapper();
  });

$(document)
  .on('shopify:section:load', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    window.utils.initializeSectionWrapper();
    window.utils.enableDisclosure();

    if (window.PXUTheme.theme_settings.enable_autocomplete) {
      window.searchAutocomplete.init();
    }

    if (window.PXUTheme.theme_settings.newsletter_popup) {
      window.newsletter_popup.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--blog-template')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--product-sidebar')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--page-gallery-template')) {
      window.gallery.init($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--gallery')) {
      window.gallery.init();
    }

    if ($parentSection.hasClass('shopify-section--page-faq-template') || $parentSection.hasClass('shopify-section--faq')) {
      window.accordion.init();
    }

    if ($parentSection.hasClass('shopify-section--cart-template')) {
      window.cart.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-promotions')) {
      window.featuredPromotions.init();
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      window.slideshow.init();
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      window.testimonials.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-product')) {
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
      window.productPage.productSwatches();
    }

    if ($parentSection.hasClass('shopify-section--map')) {
      window.map.init();
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.init();
    }

    if ($parentSection.hasClass('shopify-section--shoppable-image')) {
      window.shoppableImage.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      window.featuredCollection.init();
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
    }

    if ($parentSection.hasClass('shopify-section--video')) {
      window.video.init();
    }

    if ($parentSection.hasClass('shopify-section--product-template') || $parentSection.hasClass('shopify-section--quick-shop')) {
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
      window.productPage.productSwatches();
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--recommended-products')) {
      window.productPage.init();
    }

    if ($parentSection.hasClass('shopify-section--recently-viewed-products')) {
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      if (window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({ scrollTop: $('#new-comment').offset().top - 140 }, 'slow');
      }
    }

    if ($parentSection.hasClass('shopify-section--collection-template')) {
      window.collectionSidebarFilter.init();
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.sidebarAccordions.init();
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--contact-section')) {
      window.map.init();
    }

    if ($parentSection.hasClass('shopify-section--search-template')) {
      if (window.PXUTheme.theme_settings.enable_autocomplete) {
        window.searchAutocomplete.init();
      }
      window.collectionSidebarFilter.init();
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--header')) {
      window.meganavManager.injectAll();
      window.header.init();
    }

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.add($parentSection[0]);
    }
  });

$(document)
  .on('shopify:section:unload', e => {
    const $target = $(e.target);
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--header')) {
      window.header.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      window.slideshow.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.unload($parentSection.find('[data-logo-wrapper]'));
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      window.testimonials.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--shoppable-image')) {
      window.shoppableImage.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--search')) {
      window.searchAutocomplete.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--product-template')) {
      window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--featured-product')) {
      window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.remove($parentSection[0]);
    }

    // When sections are removed from the DOM, reinitialize the section wrapper
    window.requestAnimationFrame(() => {
      window.utils.initializeSectionWrapper();
    });
  });

$(document)
  .on('shopify:section:select', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.select($parentSection[0]);
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      window.featuredCollection.unload($parentSection);
      window.featuredCollection.init();
    }

    const evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
  });

$(document)
  .on('shopify:section:deselect', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.deselect();
    }
  });

var slider = document.querySelector('.items-slider');
var sliderItems = document.querySelectorAll('.items-slider .slider-item');
var currentSlide = 0;
var slideInterval;

function initSlider() {
  // check if slider exists on the page
  if (slider) {
    // check screen width and activate slider if less than 799px
    if (window.innerWidth < 799) {
      slideInterval = setInterval(nextSlide, 5000);
      showSlide(currentSlide);
    }
  }
}

function nextSlide() {
  hideSlide(currentSlide);
  currentSlide = (currentSlide + 1) % sliderItems.length;
  showSlide(currentSlide);
}

function showSlide(index) {
  sliderItems[index].classList.add('active');
}

function hideSlide(index) {
  sliderItems[index].classList.remove('active');
}

window.addEventListener('resize', function() {
  // if slider exists and screen width is less than 799px and slider is not active, activate it
  if (slider && window.innerWidth < 799 && !slideInterval) {
    initSlider();
  }
  // if slider exists and screen width is 799px or greater and slider is active, deactivate it
  else if (slider && window.innerWidth >= 799 && slideInterval) {
    clearInterval(slideInterval);
    slideInterval = null;
    hideSlide(currentSlide);
    currentSlide = 0;
  }
});

initSlider();

const mainDiv = document.querySelector('.multistore-dropdown');
const mainLink = document.querySelector('.multistore-dropdown .parent-link--false');
const mainUl = document.querySelector('.multistore-dropdown ul');

// add a click event listener to the document
document.addEventListener('click', function(event) {

  // check if the click event target is not the div element
  if (!mainDiv.contains(event.target)) {
 
      mainUl.style.display = 'none';
  }
  
});

// Get all text nodes recursively from an element
function getAllTextNodes(node) {
  const textNodes = [];

  function traverse(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      textNodes.push(node);
    } else {
      for (const childNode of node.childNodes) {
        traverse(childNode);
      }
    }
  }

  traverse(node);
  return textNodes;
}

// Convert the occurrences of "Votary" and its variations to uppercase
function convertVotaryToUppercase() {
  const textNodes = getAllTextNodes(document.body);

  textNodes.forEach((node) => {
    const text = node.textContent;
    const modifiedText = text.replace(/\bvotary\b/gi, (match) => {
      const uppercaseMatch = match.toUpperCase();
      return uppercaseMatch;
    });

    if (modifiedText !== text) {
      node.textContent = modifiedText;
    }
  });
}

// Call the function to convert "Votary" and its variations to uppercase and log the occurrences
convertVotaryToUppercase();


document.addEventListener("DOMContentLoaded", function() {
    // Get references to the elements
    const searchButton = document.querySelector('li[data-meganav-desktop-target="search"] .link-with-icon');
    const searchPopup = document.querySelector("header .searсh-popup");
    const closeSearchPopup = document.querySelector(".close-search-popup");

    // Click event handler for opening the search popup
    searchButton.addEventListener("click", function(e) {
        e.preventDefault();
        searchPopup.classList.add("is-visible");
        document.querySelector('html').classList.add("search-active");
    });

    // Click event handler for closing the search popup
    closeSearchPopup.addEventListener("click", function() {
        searchPopup.classList.remove("is-visible");
        document.querySelector('html').classList.remove("search-active");
    });

    // Click event handler to close the search popup when clicking outside
    // document.addEventListener("click", function(event) {
    //     if (!searchPopup.contains(event.target) && event.target !== searchButton) {
    //         searchPopup.classList.remove("is-visible");
    //     }
    // });
});

var locationSwitcher = document.getElementById("location-switcher");

locationSwitcher.addEventListener("change", function () {
  var selectedOption = locationSwitcher.options[locationSwitcher.selectedIndex];
  var dataLink = selectedOption.getAttribute("data-link");
  window.location.href = dataLink;
});

//Sticky Add to Cart button

$(document).ready(function() {
  var stickyButton = $('#sticky-add-to-cart-button');
  
  if (stickyButton.length) {
    var originalButton = $('.product-block--form .purchase-details__buttons');
    
    $(window).scroll(function() {
      if ($(window).scrollTop() > originalButton.offset().top) {
        stickyButton.addClass('active');
      } else {
        stickyButton.removeClass('active');
      }
    });
  }
});


if (document.body.classList.contains('product') && document.querySelector('.image-with-text-container')) {
  document.querySelectorAll('.image-with-text-container .description').forEach(field => {
    const maxHeight = 20.9 * 12;
    const currentHeight = field.offsetHeight;

    if (currentHeight > maxHeight) {
      field.style.height = `${maxHeight}px`;
      field.style.overflow = 'hidden';

      const readMoreBtn = document.createElement('button');
      readMoreBtn.textContent = 'Read More';
      readMoreBtn.classList.add('read-more-btn');

      const textShadowDiv = document.createElement('div');
      textShadowDiv.classList.add('textshadow');
      textShadowDiv.appendChild(readMoreBtn);

      field.insertAdjacentElement('afterend', textShadowDiv);

      readMoreBtn.addEventListener('click', () => {
        if (field.classList.contains('expanded')) {
          field.classList.remove('expanded');
          field.style.height = `${maxHeight}px`;
          readMoreBtn.textContent = 'Read More';
        } else {
          field.classList.add('expanded');
          field.style.height = 'auto';
          readMoreBtn.textContent = 'Read Less';
        }
      });
    }
  });
}

theme.utils = {
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

  wrap: function(el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  },

  debounce: function(wait, callback, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) callback.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) callback.apply(context, args);
    }
  },

  throttle: function(limit, callback) {
    var waiting = false;
    return function () {
      if (!waiting) {
        callback.apply(this, arguments);
        waiting = true;
        setTimeout(function () {
          waiting = false;
        }, limit);
      }
    }
  },

  prepareTransition: function(el, callback) {
    el.addEventListener('transitionend', removeClass);

    function removeClass(evt) {
      el.classList.remove('is-transitioning');
      el.removeEventListener('transitionend', removeClass);
    }

    el.classList.add('is-transitioning');
    el.offsetWidth; // check offsetWidth to force the style rendering

    if (typeof callback === 'function') {
      callback();
    }
  },

  // _.compact from lodash
  // Creates an array with all falsey values removed. The values `false`, `null`,
  // `0`, `""`, `undefined`, and `NaN` are falsey.
  // _.compact([0, 1, false, 2, '', 3]);
  // => [1, 2, 3]
  compact: function(array) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  serialize: function(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function(field) {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach(function(option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              '=' +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    });
    return arr.join('&');
  }
};

class ImageCompare extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.sectionId = this.dataset.sectionId;
    this.button = this.querySelector('[data-button]');
    this.draggableContainer = this.querySelector('[data-draggable]');
    this.primaryImage = this.querySelector('[data-primary-image]');
    this.secondaryImage = this.querySelector('[data-secondary-image]');

    this.calculateSizes();

    this.active = false;
    this.currentX = 0;
    this.initialX = 0;
    this.xOffset = 0;

    this.buttonOffset = this.button.offsetWidth / 2;

    this.el.addEventListener("touchstart", this.dragStart.bind(this), false);
    this.el.addEventListener("touchend", this.dragEnd.bind(this), false);
    this.el.addEventListener("touchmove", this.drag.bind(this), false);

    this.el.addEventListener("mousedown", this.dragStart.bind(this), false);
    this.el.addEventListener("mouseup", this.dragEnd.bind(this), false);
    this.el.addEventListener("mousemove", this.drag.bind(this), false);

    // Fix: Use window.addEventListener instead of window.on
    window.addEventListener('resize', theme.utils.debounce(250, () => {
      this.calculateSizes(true);
    }));

    document.addEventListener('shopify:section:load', event => {
      if (event.detail.sectionId === this.sectionId && this.primaryImage !== null) {
        this.calculateSizes();
      }
    });
  }

  calculateSizes(hasResized = false) {
    this.active = false;
    this.currentX = 0;
    this.initialX = 0;
    this.xOffset = 0;

    this.buttonOffset = this.button.offsetWidth / 2;

    this.elWidth = this.el.offsetWidth;

    this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`;

    if (this.primaryImage) {
      this.primaryImage.style.width = `${this.elWidth}px`;
    }

    if (hasResized) this.draggableContainer.style.width = `${this.elWidth / 2}px`;
  }

  dragStart(e) {
    if (e.type === "touchstart") {
      this.initialX = e.touches[0].clientX - this.xOffset;
    } else {
      this.initialX = e.clientX - this.xOffset;
    }

    if (e.target === this.button) {
      this.active = true;
    }
  }

  dragEnd(e) {
    this.initialX = this.currentX;

    this.active = false;
  }

  drag(e) {
    if (this.active) {
      e.preventDefault();

      if (e.type === "touchmove") {
        this.currentX = e.touches[0].clientX - this.initialX;
      } else {
        this.currentX = e.clientX - this.initialX;
      }

      this.xOffset = this.currentX;
      this.setTranslate(this.currentX, this.button);
    }
  }

  setTranslate(xPos, el) {
    let newXpos = xPos - this.buttonOffset;
    let newVal = (this.elWidth / 2) + xPos;

    const boundaryPadding = 50;
    const XposMin = (this.elWidth / 2 + this.buttonOffset) * -1;
    const XposMax = this.elWidth / 2 - this.buttonOffset;

    // Set boundaries for dragging
    if (newXpos < (XposMin + boundaryPadding)) {
      newXpos = XposMin + boundaryPadding;
      newVal = boundaryPadding;
    } else if (newXpos > (XposMax - boundaryPadding)) {
      newXpos = XposMax - boundaryPadding;
      newVal = this.elWidth - boundaryPadding;
    }

    el.style.transform = `translate(${newXpos}px, -50%)`;
    this.draggableContainer.style.width = `${newVal}px`;
  }
}

customElements.define('image-compare', ImageCompare);

// function customAddBtn(element) {
//   const variantId = element.getAttribute('data-productid');
//   const data = {
//     id: variantId,
//     quantity: 1
//   };
//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       'Accept': 'application/json'
//     },
//     body: JSON.stringify(data)
//   })
//   .then(response => response.json())
//   .then(data => {
//     document.dispatchEvent(new CustomEvent('cart:updated', {
//       detail: { cart: data }
//     }));
//     fetch('/cart.js')
//       .then(response => response.json())
//       .then(cart => {
//         document.querySelector('.cart-drawer').dispatchEvent(new Event('cart:refresh'));
//       });
//   })
//   .catch(error => {
//     console.error('Error adding product to cart:', error);
//     alert('Failed to add product to cart. Please try again.');
//   });
// }

  // if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
  //   $(document).on('click', '.ajax-submit', function (e) {
  //     e.preventDefault();
  //     const $addToCartForm = $(this).closest('form');
  //     const $addToCartBtn = $addToCartForm.find('.add_to_cart');

  //     // Refresh page on quick shop add to cart if on cart page
  //     if ($('body').hasClass('cart')) {
  //       $addToCartForm.submit();
  //     }

  //     $.ajax({
  //       url: '/cart/add.js',
  //       dataType: 'json',
  //       cache: false,
  //       type: 'post',
  //       data: $addToCartForm.serialize(),
  //       beforeSend() {
  //         $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
  //         $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
  //       },
  //       success() {
  //         $addToCartBtn.find('.checkmark').addClass('checkmark-active');

  //         window.setTimeout(() => {
  //           $addToCartBtn.removeAttr('disabled').removeClass('disabled');
  //           $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
  //           $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
  //         }, 1000);

  //         $.ajax({
  //           url: '/cart.js',
  //           dataType: 'json',
  //           cache: false,
  //           success(cart) {
  //             setTimeout(function () {
  //               refreshCart(cart);
  //               if ($('body').hasClass('fancybox-active')) {
  //                 $.fancybox.close();
  //               }

  //               if ($('#header').is(':visible')) {
  //                 $('#header .cart-container').addClass('active_link');
  //               } else if ($('.sticky_nav--stick').length) {
  //                 $('.sticky_nav .cart-container').addClass('active_link');
  //               } else {
  //                 $('.top-bar .cart-container').addClass('active_link');
  //               }

  //               // block scrolling on mobile
  //               if (window.PXUTheme.media_queries.medium.matches) {
  //                 const $cartContainer = $(this).parent();
  //                 if ($cartContainer.hasClass('active_link')) {
  //                   $('body').addClass('blocked-scroll');
  //                 } else {
  //                   $('body').addClass('blocked-scroll');
  //                 }

  //                 // Scroll to the top of the page unless the header is fixed
  //                 const header = document.getElementById('header');
  //                 if (header.classList.contains('mobile_nav-fixed--false')) {
  //                   window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  //                 }
  //               }
  //             }, 500);
  //           },
  //         });
  //       },
  //       error(XMLHttpRequest) {
  //         let response = eval(`(${XMLHttpRequest.responseText})`);
  //         response = response.description;
  //         $('.warning').remove();

  //         const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
  //         $addToCartForm.after(warning);
  //         $addToCartBtn.removeAttr('disabled').removeClass('disabled');
  //         $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
  //       },
  //     });

  //     return false;
  //   });
  // }


